class ExtraMeaningCardInline extends HTMLElement {
  constructor() {
    super();
    this.radioEl = null;
    this.clickTargetEl = null;
    this.isSelected = false;
  }

  connectedCallback() {
    this.radioEl = this.querySelector(".js-extra-meaning-card-inline-radio");
    this.clickTargetEl = this.querySelector(".js-meaning-card-inline");
    this.bindEvents();
    this.render();
  }

  bindEvents() {
    this.radioEl?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.toggleSelection();
    });

    this.clickTargetEl?.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (target.closest(".js-extra-meaning-card-inline-radio")) return;
      this.toggleSelection();
    });

    this.clickTargetEl?.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      this.toggleSelection();
    });
  }

  toggleSelection() {
    this.isSelected = !this.isSelected;
    this.render();
    this.dispatchSelectionEvents();
  }

  render() {
    this.classList.toggle("selected", this.isSelected);
    this.clickTargetEl?.setAttribute("aria-pressed", `${this.isSelected}`);
  }

  dispatchSelectionEvents() {
    const personalizerInline = this.closest("personalizer-inline");
    if (!personalizerInline) return;

    personalizerInline.dispatchEvent(new CustomEvent("meaningCart", { bubbles: true }));
    personalizerInline.dispatchEvent(
      new CustomEvent("updateProperties", {
        bubbles: true,
        detail: {
          properties: {
            "Scratch card": this.isSelected ? "yes" : "no",
          },
        },
      })
    );
  }
}

customElements.define("extra-meaning-card-inline", ExtraMeaningCardInline);
